import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestList.AirwallexBatchPaymentRequestCard.PaymentStatusBadge', {
    sent: 'Sent',
    processing: 'Processing',
    failed: 'Failed',
    cancelled: 'Cancelled',
    rejected: 'Rejected',
});
